export default "__VITE_ASSET__BlHoMLqz__"